var map = {
	"app/homepage/homepage.module": [
		"./src/app/homepage/homepage.module.ts",
		"default~app-homepage-homepage-module~app-portal-portal-module",
		"app-homepage-homepage-module"
	],
	"app/portal/portal.module": [
		"./src/app/portal/portal.module.ts",
		"default~app-homepage-homepage-module~app-portal-portal-module",
		"app-portal-portal-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;